import {
  Card,
  CardContent,
  Grid,
  makeStyles,
  Typography,
  Box,
  Chip,
} from "@material-ui/core";
import { MeetingRoom, Schedule, CheckCircle } from "@material-ui/icons";
import {
  collection,
  query,
  where,
  onSnapshot,
  doc,
  getDoc,
} from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useFirebase } from "../../../Firebase/FirebaseContext";
import Timer from "../../Elements/Timer";
import Legend from "../../Elements/Legend";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
  },
  header: {
    marginBottom: theme.spacing(4),
  },
  title: {
    fontWeight: 700,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(2),
  },
  gridContainer: {
    marginTop: theme.spacing(3),
  },
  card: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    cursor: "pointer",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    borderRadius: 16,
    overflow: "hidden",
    position: "relative",
    border: `2px solid ${theme.palette.divider}`,
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 12px 24px -10px rgba(0, 0, 0, 0.3)",
    },
  },
  cardFree: {
    background: "linear-gradient(135deg, #FFFFFF 0%, #F3F4F6 100%)",
    borderColor: theme.palette.divider,
  },
  cardHostess: {
    background: "linear-gradient(135deg, #454545 0%, #2D2D2D 100%)",
    borderColor: "#454545",
    color: "white",
  },
  cardTechnician: {
    background: "linear-gradient(135deg, #D35400 0%, #B84600 100%)",
    borderColor: "#D35400",
    color: "white",
  },
  cardContent: {
    padding: theme.spacing(3),
    textAlign: "center",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(2),
  },
  roomIcon: {
    fontSize: 48,
    marginBottom: theme.spacing(1),
  },
  roomName: {
    fontWeight: 600,
    fontSize: "1.25rem",
    marginBottom: theme.spacing(1),
  },
  statusChip: {
    marginTop: theme.spacing(1),
    fontWeight: 500,
  },
  timerContainer: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1, 2),
    borderRadius: 8,
    backgroundColor: "rgba(255, 255, 255, 0.1)",
  },
}));

export default function RoomsMonitoring() {
  const [rooms, setRooms] = useState([]);
  const { firebase } = useFirebase();
  const classes = useStyles();
  const history = useHistory();

  // ...
  useEffect(() => {
    const unsubscribe = onSnapshot(
      query(
        collection(firebase.db, "rooms"),
        where("laboratoryId", "==", localStorage.getItem("currentLab"))
      ),
      async (querySnapshot) => {
        const tempRooms = [];

        for (const roomDoc of querySnapshot.docs) {
          const roomData = roomDoc.data();
          let appointmentInfo = null;

          if (roomData.appointementId) {
            try {
              const appointmentRef = doc(
                firebase.db,
                "appointements",
                roomData.appointementId
              );
              const appointmentDoc = await getDoc(appointmentRef);
              if (appointmentDoc.exists()) {
                appointmentInfo = appointmentDoc.data();
              }
            } catch (error) {
              console.error(
                "Erreur lors de la récupération du rendez-vous:",
                error
              );
            }
          }

          tempRooms.push({
            room: roomData,
            id: roomDoc.id,
            appointment: appointmentInfo,
          });
        }

        tempRooms.sort((a, b) => a.room.name.localeCompare(b.room.name));
        console.log(tempRooms);
        setRooms(tempRooms);
      }
    );

    return () => unsubscribe();
  }, []);

  const getCardClasses = (data) => {
    let baseClass = classes.card;

    if (data?.room?.appointementId && data?.appointment) {
      if (data.appointment.technician_came_at) {
        return `${baseClass} ${classes.cardTechnician}`;
      } else if (data.appointment.started_at) {
        return `${baseClass} ${classes.cardHostess}`;
      }
    }
    return `${baseClass} ${classes.cardFree}`;
  };

  const getStatusInfo = (data) => {
    if (!data?.room?.appointementId) {
      return { label: "Libre", icon: <CheckCircle /> };
    }

    if (data?.appointment) {
      if (data.appointment.technician_came_at) {
        return { label: "Prélèvement en cours", icon: <Schedule /> };
      } else if (data.appointment.started_at) {
        return { label: "Patient en attente", icon: <Schedule /> };
      }
    }

    return { label: "Occupé", icon: <Schedule /> };
  };

  return (
    <div className={classes.container}>
      <Box className={classes.header}>
        <Typography variant="h3" className={classes.title}>
          Suivi des salles
        </Typography>
        <Legend />
      </Box>

      <Grid container spacing={3} className={classes.gridContainer}>
        {rooms.map((data, i) => {
          const { label, icon } = getStatusInfo(data);
          const isOccupied = !!data?.room?.appointementId;

          return (
            <Grid item xs={12} sm={6} md={4} lg={3} key={`uniqueKey-${i}`}>
              <Card
                className={getCardClasses(data)}
                elevation={0}
                onClick={() => {
                  history.push("/roomHistory", { data: data });
                }}
              >
                <CardContent className={classes.cardContent}>
                  <MeetingRoom className={classes.roomIcon} />
                  <Typography className={classes.roomName}>
                    {data?.room?.name}
                  </Typography>

                  <Chip
                    label={label}
                    icon={icon}
                    size="small"
                    className={classes.statusChip}
                    style={{
                      backgroundColor: "rgba(255, 255, 255, 0.2)",
                      color: "inherit",
                    }}
                  />

                  {isOccupied && (
                    <Box className={classes.timerContainer}>
                      <Timer roomId={data?.id} />
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
}
